/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS, undefined) {
	'use strict';

	/**
	 * Newsletter Module
	 *
	 * @author Reto Zigerlig
	 * @namespace Tc.Module
	 * @class ScNewsletter
	 * @extends Tc.Module
	 */
	Tc.Module.ScNewsletter = Tc.Module.extend({

		/**
		 * Initializes ScNewsletter and attaches events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$form = $ctx.find('form');

			// Remove the formstart for compatibility reasons with legacy newsletter
			$form.find('[name=":formstart"]').remove();

			// Attach the newsletter specific selector for the legacy newsletter submit servlet
			var defaultAction = $form.attr('action');
			if (defaultAction) {
				// the newsletter selector has to be first, we just remove all other selectors
				var updatedAction = defaultAction.replace(/\/([^/.]+)(\.[^/]+)?\.html/, '/$1.newsletter.html');
				// action for info page (update)
				if (updatedAction.indexOf('type=info') > -1) {
					updatedAction = SCS.Url.updateQueryStringParameter(updatedAction, "type", "update");
				}
				$form.attr('action', updatedAction);
				debug.log('Tc.Module.ScNewsletter', updatedAction);
			}

			// prefill values
			var json = $ctx.data('subscription');
			$ctx.find('input[type="checkbox"][value="' + (json.tags || []).join('"], input[type="checkbox"][value="') + '"]').prop('checked', true).trigger('change');
			$ctx.find('input[type="text"][data-bind="value:email"]').val(json.email || '');
			$ctx.find('input[type="radio"][value="' + (json.language || '') + '"]').prop('checked', true).trigger('change');
			debug.log('Tc.Module.ScNewsletter', json.tags, json.email, json.language);

			callback(); // this MUST be called!
		}
	});
}(window.Tc.$, window.Tc, window.SCS));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ScNewsletter.js
// module id = 181
// module chunks = 0